<template>
  <a-card title="任务模板 Tab 配置">
    <!-- <a-tabs v-model:activeKey="formSearch.region_code" @change="handleTableChange()" >
      <a-tab-pane key="" tab="全部"></a-tab-pane>
      <a-tab-pane key="CN" tab="中国 CN"></a-tab-pane>
      <a-tab-pane key="US" tab="美国 US"></a-tab-pane>
    </a-tabs>  -->
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
       
        <a-form-item>
          <a-input placeholder="ID" v-model:value="formSearch.id" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="名称(后台)" v-model:value="formSearch.tab_name" />
        </a-form-item>
         <a-form-item  label="工具 ID">
        <a-select
          :allowClear="true"
          style="width: 100px;"
          v-model:value="formSearch.tool_id"
          :options="ToolIDOptions"
          placeholder="工具 ID"
        />
      </a-form-item>
        <a-form-item  label="只看首页">
          <a-checkbox v-model:checked="formSearch.home_sorted"></a-checkbox>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            @click="handleCreate"
          >
          新建
          </a-button>
        </a-form-item>
      </a-form>
    </a-space>

    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
    <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >

      <template #tool_id="{ record }">
        <div style="width:100px;">
          {{ record.tool_id ? ToolNames[record.tool_id] : '-'}} 
        </div>
      </template>
      <template #style_name="{ record }">
        <div >
          {{ styleNames[record.style_id]}}
        </div>
      </template>
      <template #sub_type="{ record }">
        <div >
          {{ subTypeNames[record.sub_type]}} 
        </div>
      </template>
      <template #sort="{ record }">
        <a-input-group compact  style="width: 140px;">
          <a-input v-model:value="record.sorted"  style="width: 70px;" />
          <a-button type="primary" @click="handleModifySort(record)"  >设置</a-button>
        </a-input-group>
      </template>
      <template #home_sort="{ record }">
        <a-input-group compact  style="width: 140px;">
          <a-input type="number" v-model:value="record.home_sorted"  style="width: 70px;" />
          <a-button type="primary" @click="handleModifyHomeSort(record)"  >设置</a-button>
        </a-input-group>
      </template>
      <template #opeartor="{ record }">
        <a target="_blank" :href="`http://admin.xuantu.pro/home/user?user_id=${record.operator_id}`">{{Operators[record.operator_id] ? Operators[record.operator_id] : record.operator_id}}</a>
      </template>
      <template #status="{ record }">
        <a-tag v-if="record.status == 1" color="green">已上线</a-tag>
        <a-tag v-if="record.status == 0" color="gray">已下线</a-tag>
        <a-tag v-if="record.status == 2" color="yellow">预览中</a-tag>
      </template>
      <!-- <template #is_delete="{ record }">
        <a-tag v-if="record.is_delete == 1" color="gray">已删除</a-tag>
        <a-tag v-if="record.status == 0" color="green">正常</a-tag>
      </template> -->
      <template #created_at="{ record }">
       <div>创建时间: {{ record.created_at.toLocaleString() }}</div>
       <div>修改时间: {{ record.updated_at.toLocaleString() }}</div>
      </template>
      <template #action="{ record }">
       <a-space>
        <a-button @click="handleModifyStatus(record, '1')" v-if="record.status == 2" type="primary">上线</a-button>
        <a-button @click="handleModifyStatus(record, '0')"  v-if="record.status == 2 || record.status == 1"  danger >下线</a-button>
        <a-button @click="handleModifyStatus(record, '2')"  v-if="record.status == 0"  warning >沙盒</a-button>
        <a-button  warn @click="() => { handleUpdate(record) }"  >编辑</a-button>
        <!-- <a-popconfirm
          title="确定删除吗?"
          ok-text="确定"
          cancel-text="不了"
          @confirm="handleDelete(record)"
        >
          <a-button v-if="record.is_delete == 0"   danger   >删除</a-button>
        </a-popconfirm> -->
       </a-space>
      </template>
      </a-table>
  </a-card>
  <a-modal width="80%" v-model:visible="openDia" :title="formRecord.id == 0 ? '新建' : '编辑'"
  @cancel="resetForm" 
  @ok="handleConfirm" :confirm-loading="loading" destroy-on-close >
    <a-form :label-col="{ span: 8 }" :model="formRecord"   style="margin: 10px auto;" :rules="rules" ref="formRef" >
        <a-form-item  label="名称(后台)" name="tab_name">
          <a-input placeholder="用户不可见，可与标题中文一致" v-model:value="formRecord.tab_name" />
        </a-form-item>
        <a-form-item  label="工具类型"  name="tool_id">
          <a-select
            :disabled="formRecord.id > 0"
            v-model:value="formRecord.tool_id"
            :options="ToolIDOptions"
            placeholder="ToolID"
          />
        </a-form-item>
        <a-form-item label="标题(i18n)" name="i18n_key">
            <Inputi18n  v-model:valid="formRecord.i18n_valid" v-model:value="formRecord.i18n_key" />
        </a-form-item>
         <a-form-item label="首页标题(i18n)" name="home_i18n_key">
            <Inputi18n  v-model:valid="formRecord.home_i18n_valid" v-model:value="formRecord.home_i18n_key" />
        </a-form-item>
<!--         
        <a-form-item required label="国家地区" name="region_code">
          <a-input-group compact style="width: 300px; display: flex;">
            <a-select
              style="width: 90%"
              v-model:value="formRecord.region_code"
              :options="NationCodes"
              placeholder="国家地区"
            />
            <a-input placeholder="国家地区" v-model:value="formRecord.region_code" />
            
          </a-input-group>
          <p>*需要展示模版的国家地区 </p>
        </a-form-item> -->
        <!-- <a-form-item   required label="分类"  name="category">
          <a-input placeholder="category" v-model:value="formRecord.category" />
        </a-form-item> -->
        <a-form-item required label="编辑器排序" name="sorted">
          <a-input type="number"  placeholder="sorted" v-model:value="formRecord.sorted" />
          <p>*数字越大越靠前 </p>
        </a-form-item>
         <a-form-item  label="首页Tab 排序" name="home_sorted">
          <a-input type="number" placeholder="home_sorted" v-model:value="formRecord.home_sorted" />
        </a-form-item>
        <a-alert v-if="formRecord.i18n_valid "  type="success" message="支持 i18n" banner />
        <a-alert v-else  type="error" message="未生成 i18n 文案" banner />
      </a-form>
  </a-modal>
  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  onMounted} from 'vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import Inputi18n from '@/components/Inputi18n.vue'
import { Modal, message } from 'ant-design-vue';
import {useRoute} from 'vue-router'

import { Operators, StyleNames, SubTypeNames, NationCodes, ToolNames, ToolIDOptions} from '@/utils/macro'
import {generateRandomString} from '@/utils/string'
const DefaultRecord = {
  "id": 0,
  "tab_name": "",
  "tool_id": "",
  "style_id": "",
  "i18n_valid": false,
  "sorted":"100",
  "category":"",
  "sub_type": "",
  "i18n_key": "",
  'home_i18n_valid': false,
  "home_i18n_key": "",
  "home_sorted":"0",
  "status": 0
}
export default defineComponent({
  components: {
    Inputi18n,
    SearchOutlined
  },
  data(){
    return {
      ToolIDOptions: ToolIDOptions,
      ToolNames :ToolNames,
      styleNames :StyleNames,
      NationCodes: NationCodes,
      subTypeNames: SubTypeNames,
      Operators,
      loading: false,
      openDia: false,
      dataSource: [],
      action_image_index: 0,
      formRecord: {
        ...DefaultRecord
      },
      rules:{
        tab_name: [
          { required: true, message: 'required', trigger: 'change' },
        ],
        tool_id: [
          { required: true, message: 'required', trigger: 'change' },
        ],
        i18n_key: [
          { required: true, message: 'required', trigger: 'change' },
        ],
      },
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
      status: [
      {
          label: '全部',
          value: ''
        },
        {
          label: '上线',
          value: '1'
        },
        {
          label: '下线',
          value: '0'
        },
        {
          label: '预览',
          value: '2'
        },
      ],
      optionTabs: [],
      formSearch: {
        id:'',
        tool_id: '',
        category: '',
        tab_name:'',
        style_id: '',
        sub_type: '',
        status: '',
      },
    }
  },
  watch: {
    'formSearch.home_sorted': {
      handler(newVal, oldVal) {
        this.formSearch.home_sorted = newVal
        this.handleTableChange()
      }
    }
  },
  mounted(){
    const route = useRoute()
    if (route.query['style_id']) {
      this.formSearch.style_id = route.query['style_id']
    }
     if (route.query['tool_id']) {
      this.formSearch.tool_id = route.query['tool_id']
    }
    if (route.query['id']) {
      this.formSearch.id = route.query['id']
    }
    if (route.query['sub_type']) {
      this.formSearch.sub_type = route.query['sub_type']
    }
    this.handleTableChange()
  },
  methods: {
    async handleConfirm(){
      if (!(this.formRecord.i18n_valid)) {
        message.error('文案不支持国际化，请填写国际化文案')
        return
      }
      if (this.formRecord.id) {
        const rsp = await request.put(`/api/creation/option_tabs/${this.formRecord.id}`, {
          ...this.formRecord,
          sorted: +this.formRecord.sorted,
          home_sorted: +this.formRecord.home_sorted,
        })
      } else {
        const rsp = await request.post('/api/creation/option_tabs', {
          ...this.formRecord,
          sorted: +this.formRecord.sorted,
          home_sorted: +this.formRecord.home_sorted,
        })
      }
     
      this.openDia = !this.openDia
      this.loading = false
      this.handleTableChange({
        ...this.pagination
      })
    },
    handleCreate(){
      this.openDia = true
      let data = {
        ...DefaultRecord
      }
      data.region_code = this.formSearch.region_code
      if (data.region_code == "") {
        data.region_code = "CN"
      }
      const randomid = generateRandomString(10)
      data.i18n_key = "tab.name." + randomid
      data.home_i18n_key = "tab.name.home_" + randomid
      data.tool_id = this.formSearch.tool_id
      data.style_id = this.formSearch.style_id
      data.sub_type = this.formSearch.sub_type
      this.formRecord = data
    },
    handleUpdate(record){
      this.openDia = true
      // console.log(record)
      let data = {
        ...record,
        sorted: +record.sorted,
      }
      data.i18n_valid = true
      // data.home_i18n_valid = true
      this.formRecord = data
    },
    async handleModifyHomeSort(record) {
      this.loading = true
      await request.put(`/api/creation/option_tabs/${record.id}`, {
        home_sorted: +record.home_sorted,
      })
      this.loading = false
    },
    async handleModifySort(record){
      this.loading = true
      await request.put(`/api/creation/option_tabs/${record.id}`, {
        sorted: +record.sorted,
      })
      this.loading = false
    },
    async handleModifyStatus(record, status){
      this.loading = true
      await request.put(`/api/creation/option_tabs/${record.id}`, {
        status: +status,
      })
      this.loading = false
      this.handleTableChange({
        ...this.pagination
      })
    },
    resetForm() {
      this.formRecord = {
       ...DefaultRecord
      }
      this.$refs.formRef.resetFields();
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      const rsp = await request.get('/api/creation/option_tabs', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        ...this.formSearch
      })
      this.loading = false
      if (rsp.data.list == null) {
        this.noticeMessage = '暂无数据'
        this.dataSource = []
        return
      }
      for (let i = 0; i < rsp.data.list.length; i++) {
        rsp.data.list[i].created_at = new Date(rsp.data.list[i].created_at)
        rsp.data.list[i].updated_at = new Date(rsp.data.list[i].updated_at)
        if (rsp.data.list[i].i18n_key != "") {
          rsp.data.list[i].name_i18n_valid = true
        }
        if (rsp.data.list[i].home_i18n_key != "") {
          rsp.data.list[i].home_i18n_valid = true
        } else {
           rsp.data.list[i].home_i18n_key = "tab.name.home_" + generateRandomString(10)
        }
      }
      this.dataSource = [].concat(rsp.data.list)
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: 'Tab',
          dataIndex: 'tab_name',
          key: 'tab_name',
        },
        {
          title: '工具',
          dataIndex: 'tool_id',
          key: 'tool_id',
          slots: { customRender: 'tool_id' },
        },  
        // {
        //   title: '任务类型',
        //   dataIndex: 'style_id',
        //   key: 'style_id',
        //   slots: { customRender: 'style_name' },
        // },  {
        //   title: '子任务',
        //   dataIndex: 'sub_type',
        //   key: 'sub_type',
        //   slots: { customRender: 'sub_type' },
        // },
        // {
        //   title: '地区',
        //   dataIndex: 'region_code',
        //   key: 'region_code',
        // },
        
        {
          title: '排序',
          slots: { customRender: 'sort' },
        },
        {
          title: '首页排序',
          slots: { customRender: 'home_sort' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          slots: { customRender: 'created_at' },
        },
        {
          title: '操作人 ID',
          dataIndex: 'operator_id',
          key: 'operator_id',
          slots: { customRender: 'opeartor' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>